<template>
  <transition name="forward">
    <div v-if="boxshow" class="orderSearchBg bg-yellow">
      <div class="header">
        <bg-yun>
          <div class="top-search">
            <button class="back-btn color-white font-0-8" style="text-align: center"  @click.stop="btnBack()">
              <!--<img src="../../assets/image/arrow-left.png" style="pointer-events: none;" width="20">-->
              返回
            </button>
            <input type="text" class="search-area" v-model="text" @input="textChanged()" placeholder="请输入菜品名称或拼音首字母"  />
          </div>
        </bg-yun>
      </div>
      <div class="content-search" ref="searchScroller">
        <!--<scroller ref="searchScroller">-->
          <div style="display: none">{{orderedTotal}}</div>
          <div class="padding-10-16 color-brown font-0-9" v-if="text">系统为您找到了：</div>
          <div v-for="(type, index) in types"  :key="index">
            <div v-for="order in filterArray(type.menuItem,['name','memberNo'],text) " @click="clickOrder(order,type)">
              <noPicMode :parent="that" :order="order" :type = "type" ref="noPicMode"><div></div></noPicMode>
            </div>
          </div>
          <div class="padding-10-16 color-brown font-0-9">以下是本店特色菜推荐：</div>
          <div v-for="type in types" >
            <div v-for="order in type.menuItem" v-if="order.picMode == 1" @click="clickOrder(order,type)">
              <noPicMode :parent="that" :order="order" :type = "type" ref="noPicMode"><div></div></noPicMode>
            </div>
          </div>
        <!--</scroller>-->
      </div>
      <suitMode ref="suitMode"></suitMode>
      <nosuitMode ref="nosuitMode"></nosuitMode>
      <alertnum ref="alertnum"></alertnum>
    </div>
  </transition>
</template>
<script >
  import bgyun from '../bg-yun/bgyun.vue';

  import alertnum from '../alertnum/alertNum';
  import ServiceUtil from '../../service/ServiceUtils';
  import noPicMode from "../noPicMode/noPicMode";
  import nosuitmode from "../noSuitMode/nosuitmode";
  import suitmode from "../suitMode/suitmode";
  export default {
    name: 'searchOrder',
    data () {
      return {
        types:[],
        text:'',
        that:this,
        boxshow:false,
        orderedTotal:ServiceUtil.orderedTotal
      }
    },
    components:{
      'bg-yun':bgyun,
      'noPicMode':noPicMode,
    'nosuitMode':nosuitmode,
      'suitMode':suitmode,
      'alertnum':alertnum
    },
    methods:{
      togglebox:function(){
        this.boxshow = !this.boxshow;
        this.text="";
      },

      /**
       * 搜索值变化时，滚动区域可视化大小有变化，滚动区域需及时刷新
       **/
      textChanged(){
        console.log()
        // this.$refs.searchScroller.resize();
        this.$refs.searchScroller.scrollTo(0,0);
      },

      /**
       * 点击单个菜品
       * @param order
       * @param type
       */
      clickOrder(order,type){
        if(order.isSaleout)return;
        order.num = 1;
        if(type.isGroup==0){
          if(order.memoflag==1){
            //呼叫配菜
            this.$refs.nosuitMode.togglebox(type,order,()=>{
              this.boxshow = false;
            });
          }else if(order.remark.length>0){
            //有加菜项
            this.$refs.nosuitMode.togglebox(type,order,()=>{
              this.boxshow = false;
            });
          }else if(order.picMode!=0){
            //有图
            this.$refs.nosuitMode.togglebox(type,order,()=>{
              this.boxshow = false;
            });
          }else if(order.standards.length>1){
            //多规格
            this.$refs.nosuitMode.togglebox(type,order,()=>{
              this.boxshow = false;
            });
          }else {
            //弹框点菜
            this.$refs.alertnum.togglebox(type,order,(food)=>{
              let type = {
                code:food.code,
                name:food.name,
                ename:food.sndname||"",
                isGroup:0
              };
              this.boxshow = false;
              let order = food.menuItem;
              ServiceUtil.setNoSuitData(type,order);

            });
          }
        }else {
//  套餐
          this.$refs.suitMode.togglebox(order,()=>{
           this.boxshow = false;
          });
        }

      },
      btnBack(){
        this.boxshow = false;
      }
    },
    mounted(){
      this.types=ServiceUtil.menuData;
    }
  }
</script>
<style scoped lang="scss">
  @import "../../assets/css/style";
  .color-brown{color:#a38e5e}
  .font-0-9{font-size: 0.9em;}

  .bg-yellow{background: #F7F3E7;}
  .color-white{color:#ffffff}
  .padding-10-16{padding: 10px 16px;}
  .top-search{
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    padding: 5px;
  }
  .font-0-8{font-size: 0.8em;}
  .top-search button{
    padding: 0;
    border: none;
  }
  .top-search input{
    padding: 0;
  }
  .back-btn{
    flex: 1;
    height: 38px;
    background-color: #CEB66B;
    border-radius: 5px;
    text-align: left;
    line-height: 38px;
  }
  .back-btn img{
    vertical-align: middle;
    margin-left: 5px;
  }

  .header{
    height: 50px;
    position: fixed;
    top:0;
    left: 0;
    right: 0;
  }
  .search-area{
    flex: 4;
    background-color: #ded8b5;
    border: none;
    height: 38px;
    line-height: 38px;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    margin-left: 5px;
  }
  .content-search{
    position: fixed;
    top:60px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  input::-webkit-input-placeholder {
    /* placeholder颜色  */
    color: #ac965c;
    /* placeholder字体大小  */
    font-size: 14px;
    /* placeholder位置  */
  }

  .orderSearchBg{
    position: fixed;top: 0;right: 0;left: 0;bottom: 0;z-index: 99;
  }



</style>



// WEBPACK FOOTER //
// src/components/searchOrder/searchorder.vue